class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.closeTimeout = null;
    this.isHoverEnabled = false;

    // Check if we're on desktop (hover should only work on desktop)
    this.checkHoverEnabled();
    window.addEventListener('resize', () => this.checkHoverEnabled());

    // Add hover event listeners
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      
      // Also listen to submenu hover to keep menu open
      const submenu = this.mainDetailsToggle.querySelector('.header__submenu, .mega-menu__content');
      if (submenu) {
        submenu.addEventListener('mouseenter', this.onSubmenuEnter.bind(this));
        submenu.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      }
    }
  }

  checkHoverEnabled() {
    // Only enable hover on desktop (990px and above)
    this.isHoverEnabled = window.matchMedia('(min-width: 990px)').matches;
  }

  onMouseEnter(event) {
    if (!this.isHoverEnabled) return;

    // Clear any pending close timeout
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    // Open menu on hover with a small delay to prevent accidental opens
    this.hoverTimeout = setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
        }
        this.onToggle();
      }
    }, 100); // Small delay to prevent accidental opens
  }

  onSubmenuEnter() {
    // Keep menu open when hovering over submenu
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    // Also clear any pending open timeout since menu is already open
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  onMouseLeave(event) {
    if (!this.isHoverEnabled) return;

    // Clear any pending open timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    // Check if we're moving to the submenu
    const submenu = this.mainDetailsToggle.querySelector('.header__submenu, .mega-menu__content');
    if (submenu && event.relatedTarget) {
      // Check if the related target (where mouse is going) is within the submenu
      if (submenu.contains(event.relatedTarget) || submenu === event.relatedTarget) {
        return; // Don't close if moving to submenu
      }
    }

    // Close menu when mouse leaves with a small delay to allow moving to submenu
    this.closeTimeout = setTimeout(() => {
      // Double check that mouse is not over menu or submenu
      const menuRect = this.mainDetailsToggle.getBoundingClientRect();
      const submenuRect = submenu ? submenu.getBoundingClientRect() : null;
      const mouseX = event.clientX || 0;
      const mouseY = event.clientY || 0;

      const isOverMenu = mouseX >= menuRect.left && mouseX <= menuRect.right &&
                         mouseY >= menuRect.top && mouseY <= menuRect.bottom;
      const isOverSubmenu = submenuRect && mouseX >= submenuRect.left && mouseX <= submenuRect.right &&
                            mouseY >= submenuRect.top && mouseY <= submenuRect.bottom;

      if (!isOverMenu && !isOverSubmenu) {
        this.close();
      }
    }, 250); // Small delay to allow moving to submenu
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    // Clear any pending timeouts
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
